<template>
  <div>
      <v-row>
          <v-col v-for="pricinglists in get_plan_list" :key="pricinglists.id">
            <v-card
              class="mx-auto"
              max-width="340"
            >
              <v-card-text>
               <!--  <span class="popular-plan" v-if="pricinglists['name'] == 'Gold'">MOST POPULAR PLAN</span> -->
                <div class="plan-detailbox">
                    <h3>{{pricinglists['name']}}</h3>
                    <p>{{pricinglists['description']}}</p>
                    <h2><span>&#8377</span> {{pricinglists['amount']}}/<span class="light-weight">{{pricinglists['period'] == 'monthly' ? 'mo' : 'yr'}}</span></h2>
                    <ul>
                      <li v-for="json_decoded_notes in pricinglists['json_decoded_notes']">{{json_decoded_notes['note']}}</li>
                    </ul>
                    <div class="choose-box">
                        <p>Read & Accept <a @click="openTermOfServices">Terms & Conditions</a></p>
                        <button  class="btn choose-btn" style="background-color: #f19700 !important;color: #fff !important;height: 46px !important;font-family: Work Sans,sans-serif;min-width: 200px !important;" v-if="pricinglists['is_plan_active'] == 1" @click="cancel">CANCEL</button>
                        <button v-else id="rzp-button1" class="btn choose-btn active" @click="choosePlan(pricinglists['amount'],pricinglists['id'],pricinglists['plan_id'],['period'],pricinglists['currency'],pricinglists['name'])">UPGRADE NOW</button>
                    </div>
                </div>
              </v-card-text>

            </v-card>
          </v-col>
      </v-row>
      <modal name="termsandservices"> 
        <span> <button type="button" class="close" 
      @click="close" style="float: right;"> X&nbsp;&nbsp;&nbsp;&nbsp; 
      </button></span></br>
        This is Term & Conditions</modal>
  </div>
</template>

<script>
import { Auth } from 'aws-amplify';
import JwtService from ".././common/jwt.service";
import { CANCEL_SUBSCRIPTION, UPDATE_PROFILE_DETAIL } from "../../store/actions.type";
import { isEmpty } from 'lodash';
   export default {
       data: () => ({
          get_plan_list: '',
          amount:'',
          expiry_date_by:'',
      }),
      computed: {  
        isDataEmpty: function () {
          return isEmpty(this.$store.getters.getProfileDetail.data);
        },
      },
      mounted (){
        if(!this.isDataEmpty){
          this.appendPlanList();
        }
        Fire.$on('cancelPlan', ()=>{
          this.appendPlanList();
        });
      },
      unmounted(){
        this.appendPlanList();
      },
       methods: {
        openTermOfServices(){
            this.$modal.show("termsandservices");
          },
          close(){
            this.$modal.hide("termsandservices");
          },
          appendPlanList(){
            this.get_plan_list = this.$store.getters.getProfileDetail.data.subscription_plans.monthly_plan;
            this.expiry_date_by = this.$store.getters.getProfileDetail.data.plan_expiry_by;
          },
          choosePlan(amount,id,plan_id,period,currency,pricingListName){
            swal.fire({
              title: 'Upgrade Subscription',
              text: "You can upgrade plan after end of current subscription.",
              icon: 'warning',
              showCancelButton: false,
              confirmButtonColor: '#051d42',
              confirmButtonText: 'OK',
            }).then((result) => {
              if (result.isConfirmed) {
                
              }
            })
          },
          cancel(){
            swal.fire({
              title: 'Are you sure?',
              text: "You want to cancel this subscription.",
              icon: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#051d42',
              cancelButtonColor: '#f19700',
              confirmButtonText: 'Yes',
              cancelButtonText:'No'
            }).then((result) => {
                if (result.isConfirmed) {
                  this.$loading(true);
                  this.$store.dispatch(CANCEL_SUBSCRIPTION, {
                    data: {
                      aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
                      name: this.$store.getters.getUserDetails.user_name,
                      email: this.$store.getters.getUserDetails.email,
                    },
                    api: 'cancel-subscription',
                  }).then(() => {
                    this.$loading(false);
                    if (this.$store.getters.getCancelSubscriptionData.data.status == 'error') {
                      // this.error_message = response.message;
                      return [];
                    }else{
                      swal.fire(
                      'Cancelled!',
                      'Your plan cancelled successfully.',
                      'success'
                      )
                    let updatedDetail = [
                      {key:'is_plan_active', value:this.$store.getters.getCancelSubscriptionData.data.is_plan_active},
                      {key:'subscription_plans', value:this.$store.getters.getCancelSubscriptionData.data.subscription_plans},
                      {key:'show_add_family_member_button', value:this.$store.getters.getCancelSubscriptionData.show_add_family_member_button}
                    ]
                    this.$store.dispatch(UPDATE_PROFILE_DETAIL,updatedDetail)
                    Fire.$emit('cancelPlan');
                    this.$router.push({ name: "pricingPlan" }).catch(()=>{});
                    }
                  })
                  .catch(function (error) {
                    this.$loading(false);
                  });
              }
            })
          },
        },
        
}
</script>